import React, { Component } from 'react';
import { compose } from 'recompose';

import { withAuthorization } from '../../../session/index';
import { Container } from 'reactstrap';
import Post from './Post';

const INITIAL_STATE = {};

class Grid extends Component {
    state = { ...INITIAL_STATE };

    render() {
        const { posts, activeTabPosts, pendingPosts, activeTabMyPosts, refreshGrid } = this.props;
        return (
            <Container fluid>
                {posts &&
                    posts.map((post, index) => {
                        return (
                            <Post
                                key={index}
                                post={post}
                                isPendingPost={pendingPosts}
                                refreshGrid={refreshGrid}
                                activeTabMyPosts={activeTabMyPosts}
                                activeTabPosts={activeTabPosts}
                                onPostReviewed={this.props.onPostReviewed}
                                onPostAnswered={this.props.onPostAnswered}
                                onPostRead={this.props.onPostRead}
                            />
                        );
                    })}
            </Container>
        );
    }
}

//const condition = authUser => !!authUser && authUser.acceptPolicy === true;
const condition = authUser => !!authUser;

export default compose(withAuthorization(condition))(Grid);
